import script from "./tools-list.vue?vue&type=script&setup=true&lang=js"
export * from "./tools-list.vue?vue&type=script&setup=true&lang=js"

import "./tools-list.vue?vue&type=style&index=0&id=18c44964&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-18c44964"]])

export default __exports__